var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.218 6.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 20h24v24H20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -5.358 -5.358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 20.25c-6.49 0-11.75 5.26-11.75 11.75S25.51 43.75 32 43.75 43.75 38.49 43.75 32 38.49 20.25 32 20.25m1.25 17.62a1.25 1.25 0 0 1-2.5 0v-7.44a1.25 1.25 0 0 1 2.5 0zm-.1-11.26c-.06.15-.15.29-.27.4-.12.12-.25.21-.4.28-.15.06-.32.09-.48.09-.34 0-.65-.13-.89-.37-.11-.11-.21-.25-.27-.4a1.28 1.28 0 0 1 .27-1.36c.29-.29.73-.43 1.13-.34.08.01.16.04.23.07.08.03.15.07.22.11.07.05.13.1.19.16.23.23.37.55.37.88 0 .17-.03.33-.1.48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.adce4fea45bdc9c16316d92d8ebe3f16.svg";
export { ForwardRef as ReactComponent };